import { v4 as uuid } from "uuid";
import { boolean, date, object, string, ObjectSchema } from "yup";

import type { Trim } from "@/types";

export const trimSchema: ObjectSchema<Trim> = object({
  _id: string()
    .uuid()
    .required()
    .default(() => uuid()),
  _rev: string().optional(),
  _deleted: boolean().optional(),
  type: string().ensure().required().oneOf(["trim"]).default("trim"),
  createdAt: date().optional(),
  updatedAt: date().optional(),
  horseId: string().label("Horse").uuid().required(),
  trimDate: date().label("Trim date").required(),
  notes: string().label("Notes").ensure(),
});
